module.exports = __webpack_public_path__ + "img/1557614099889725442.4da3278f.png";